import { ComponentRenderer } from 'app/src/features/Catalog/components/ComponentRenderer'
import { pageconfigurationsApi } from 'app/src/services/welfareportal'
import { useComponentRenderer, usePageTitle, useTranslation, useWebAppContext } from 'app/src/shared/hooks'
import { useEffect, type ReactElement } from 'react'

export function Catalog(): ReactElement {
  const context = useWebAppContext()
  const { getPage } = useComponentRenderer()
  const catalogPageConfig = pageconfigurationsApi.usePageRequestGet({
    pathParams: { id: 'catalog', templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId },
  })
  const { t } = useTranslation('home')
  usePageTitle(t('AppBar.Catalog'))
  useEffect(() => {
    context.update({ breadCrumbItems: [] })
    //Evita loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ComponentRenderer(getPage(catalogPageConfig?.data))
}
